var map = {
	"./Fazi.svg": 17907,
	"./New.svg": 47119,
	"./Plinko.svg": 41744,
	"./Poker.svg": 68290,
	"./Roulette.svg": 17055,
	"./SetDefault.svg": 69608,
	"./Slot.svg": 50119,
	"./default.svg": 55926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8711;